import { render, staticRenderFns } from "./VTokenInput.vue?vue&type=template&id=6e2c22d5&scoped=true"
import script from "./VTokenInput.vue?vue&type=script&lang=js"
export * from "./VTokenInput.vue?vue&type=script&lang=js"
import style0 from "./VTokenInput.vue?vue&type=style&index=0&id=6e2c22d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c22d5",
  null
  
)

export default component.exports